import React, { Component, PropTypes } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import { Link } from 'react-router-dom';
import { appService } from '../../_services';
import { authHeader, config } from '../../_helpers';
import DocumentMeta from 'react-document-meta';
window.React = React

export class ReviewOrder extends Component {
    displayName = ReviewOrder.name
    
    constructor(props) {
        super(props);
        this.state = {
            key: '3',
            ReviewOrder: [],
            fields: {},
            errors: {}
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleCountriesChange = this.handleCountriesChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleChange(event) {

        let setvalue = '';
        if (event.target.type == "checkbox") {
            setvalue = event.target.checked
        }
        else {
            setvalue = event.target.value
        }

        this.setState({ [event.target.id]: setvalue });
        let fields = this.state.fields;
        fields[event.target.id] = setvalue;
        this.setState({ fields });
    }

    handleCountriesChange(event) {

        let fields = this.state.fields;
        fields[event.target.id] = event.target.value;
        
        var self = this;
        self.setState({ [event.target.id]: event.target.value, fields });
        appService.getAll('Cart/GetByCountry?CountryId=' + event.target.value).then(function (response) {
                this.setState({
                    regions: response,
                })
            })
    }

    handleSelect(Activekey) {
        
        if (Activekey == '2') {
            document.getElementById('controlled-tab-example-tab-2').click();
        }


    }


    handleSave(event) {

        if (this.handleValidation()) {
            event.preventDefault();


            //submitform
            //const requestOptions = {
            //    method: 'POST',
            //    headers: authHeader(),
            //    body: JSON.stringify(this.state),
            //    cache: 'no-cache',
            //};

            //fetch(config.apiUrl + '/Cart/UpdateYourDetails', requestOptions)
            //    .then(function (data) {

            appService.getAll('Cart/MakePayment').then(function (response) {
                            //this.setState({ MakePayment : response });
                        });

                //});

            //endsubmitform
        }
    }


    handleValidation() {

        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (!this.state.firstname) {
            formIsValid = false;
            errors["firstname"] = "Required field!";
        }

        if (!this.state.lastname) {
            formIsValid = false;
            errors["lastname"] = "Required field!";
        } 

        this.setState({ errors: errors });
        if (!formIsValid) {
            window.scrollTo({
                top: 200,
                behavior: 'smooth',
            });
            return false;
        }

        return true;
    }
    //componentDidMount() {
        
    //    var self = this;
 
    //    appService.getAll('Cart/ReviewOrder').then(function (response) {
    //            self.setState({
    //                //usersubscriptionid: response.usersubscriptionid,
    //                //firstname: response.cartUserVM.firstname,
    //                //lastname: response.cartUserVM.lastname,
    //                //organisation: response.cartUserVM.organisation,
    //                //countryId: response.cartUserVM.countryId,
    //                //countryName: response.cartUserVM.countryName,
    //                //countries: response.cartUserVM.countries,
    //                //address1: response.cartUserVM.address1,
    //                //address2: response.cartUserVM.address2,
    //                //city: response.cartUserVM.city,
    //                //regionId: response.cartUserVM.regionId,
    //                //regionName: response.cartUserVM.regionName,
    //                //regions: response.cartUserVM.regions,
    //                //zip: response.cartUserVM.zip,
    //                //phoneNo: response.cartUserVM.phoneNo,
    //                //vatnumber: response.cartUserVM.vatnumber,
    //                //emailAddress: response.cartUserVM.emailAddress,
    //                //saveForQuickCheckout: response.cartUserVM.saveForQuickCheckout,
    //                ////shipping
    //                //shippingfirstname: response.cartUserVM.shippingfirstname,
    //                //shippinglastname: response.cartUserVM.shippinglastname,
    //                //shippingorganisation: response.cartUserVM.shippingorganisation,
    //                //shippingcountryId: response.cartUserVM.shippingcountryId,
    //                //shippingcountryName: response.cartUserVM.shippingcountryName,
    //                //shippingcountries: response.cartUserVM.shippingcountries,
    //                //shippingaddress1: response.cartUserVM.shippingaddress1,
    //                //shippingaddress2: response.cartUserVM.shippingaddress2,
    //                //shippingcity: response.cartUserVM.shippingcity,
    //                //shippingregionId: response.cartUserVM.shippingregionId,
    //                //shippingregionName: response.cartUserVM.shippingregionName,
    //                //shippingregions: response.cartUserVM.shippingregions,
    //                //shippingzip: response.cartUserVM.shippingzip,
    //                //shippingphoneNo: response.cartUserVM.shippingphoneNo,
    //                //shippingvatnumber: response.cartUserVM.shippingvatnumber,

    //                ////Tax
    //                //totalTax: response.totalTax,

    //            });
    //        });
    //}

    render() {

        const meta = {
            title: "Kluwer Law Online - Review order",
            canonical: window.location.href,
        }


        return (
            <DocumentMeta {...meta}>
            <div>
                
                
                <ul className="list-group list-group-flush">
                    <li className="list-group-item px-0 border-0" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                        <div className="row">
                            <div className="col col-lg-6 font-400">Company name</div>
                            <div className="col font-400">VAT number</div>
                            <div className="col blue text-right" onClick={() => this.handleSelect("2")}>Edit VAT</div>
                        </div>
                    </li>
                    <li className="list-group-item px-0 py-4">
                        <div className="row">
                            <div className="col col-lg-6">{this.state.organisation}</div>
                            <div className="col">{this.state.vatnumber}</div>
                            <div className="col blue text-right"></div>
                        </div>
                    </li>
                    <li className="list-group-item px-0" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                        <div className="row">
                            <div className="col col-lg-6 font-400">Billing address</div>
                            <div className="col font-400">Shipping address</div>
                            <div className="col blue text-right" onClick={() => this.handleSelect("2")}>Edit addresses</div>
                        </div>
                    </li>
                    <li className="list-group-item px-0 py-4">
                        <div className="row">
                            <div className="col col-lg-6">
                                <p className="m-0 p-0 ">{this.state.firstname + ' ' + this.state.lastname}<br></br>test <br></br>{this.state.address1} {this.state.address2} <br></br>{this.state.regionName}, {this.state.countryName} {this.state.phoneNo}</p>
                            </div>
                            <div className="col">
                                <p className="m-0 p-0">REISHA GOLDMAN <br></br>Wolters Kluwer <br></br>76 9th Ave. TEST DO NOT PROCESS <br></br>New York, New York 10011-4962</p>
                            </div>
                            <div className="col blue"></div>
                        </div>
                    </li>
                    <li className="list-group-item px-0" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                        <div className="row">
                            <div className="col col-lg-6 font-400">Email address</div>
                            <div className="col font-400"></div>
                            <div className="col blue text-right" onClick={() => this.handleSelect("2")}>Edit email</div>
                        </div>
                    </li>
                    <li className="list-group-item px-0 py-4">
                        <div className="row">
                            <div className="col col-lg-6">{this.state.emailAddress}</div>
                        </div>
                    </li>
                </ul>
                <br></br>
                <div className="row my-5">
                    <div className="col">
                        <button type="button" className="btn float-left back-btn rounded-0" onClick={() => this.handleSelect("2")}>Back</button>
                    </div>
                    <div className="col">
                        <button type="button" onClick={() => this.handleSelect("4")} className="btn btn-info next float-right rounded-0">Make payment</button>
                    </div>
                </div>
            </div>
                </DocumentMeta>
        );
    }
}
export default ReviewOrder;


// WEBPACK FOOTER //
// ./src/components/Shopping Cart/ReviewOrder.jsx